import { useDispatch } from 'react-redux'
import { AppDispatch } from '../store'

/**
 * A type-compatible version of dispatch (allows dispatching all actions belonging to the store)
 */
export const useAppDispatch: () => AppDispatch = useDispatch
